module.exports = __webpack_public_path__ + "@/assets/img/038-boy-16.e74507ba.svg";